import React, { useState, useEffect } from 'react';
import { ProjectModel } from '@models/Models';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useImage from '@hooks/useImage';

interface ProjectProps {
    item: ProjectModel; // Replace with actual project type
}

const Project: React.FC <ProjectProps> = ({ item }) => {
    const navi = useNavigate();
    const [clienLogoURL ,setClienLogoURL] = useState("");
    const { getPublicURL } = useImage();

    useEffect(() => {
        imagesGetter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item])

    const imagesGetter = async () => {
        const imageResult = await getPublicURL(item.logoClient as string);

        if(imageResult.success) {
            setClienLogoURL(imageResult.data);
        }
    }

    return (
        <Row onClick={() => navi(`/projekt-bearbeiten/${item.id}`)} className='project-comp shadow myBorder'>
            <Col xs={12} lg={6}>
                <h4 className='text-black-50'>{item.name}</h4>
                <p className='text-black-50 text-info'>{new Date(item.createdAt as string).toDateString()}</p>
            </Col>
            <Col xs={12} lg={6} className='d-flex align-items-center justify-content-end'>
                <div className='image-container'>
                    <img
                        src={ clienLogoURL }
                        alt="Client Logo"
                        className='preview-image'
                    />
                </div>
                
            </Col>
        </Row>
    )
}

export default Project